import { registerBlockType, getBlockType } from '@wordpress/blocks'
import { useGetPosts } from '../../hooks/useGetPosts';

if(!getBlockType('lazer-kitty/example-hook-block')) {
    registerBlockType('lazer-kitty/example-hook-block', {
        title: 'Example Hook Block',
        icon: 'smiley',
        category: 'common',
        edit: (props) => editComponent(props),
        save: (props) => saveComponent(props),
        attributes: {
            posts: {type: 'array'}
        },
    });
}

function editComponent({setAttributes}) {
    const {data:response, isLoading} = useGetPosts();

    // console.log(response); // view data structure
    const posts = response?.posts?.nodes;

    if(!posts && !isLoading) return (<section>Data load failed.</section>)
    if(!posts && isLoading) return (<section>Loading data.</section>);

    if(posts && !isLoading) {
        setAttributes({ posts: posts }); // set block attribute value
        return posts.map(post => post.title); // display block
    }
}

function saveComponent({attributes}) {
    const {posts} = attributes; // get saved data from attributes
    return <>{posts.map(post => <div>{post.title}</div>)}</>;
}